var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibraryMaxillary1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 164,
    viewBox: "0 0 600 164",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1022_124501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.999 78.8897C517.999 78.8897 515.605 101.895 532.488 109.908C549.37 117.922 538.611 118.56 555.703 123.414C555.703 123.414 568.226 125.665 577.928 106.112C587.63 86.5581 603.814 52.9357 598.465 8.19345C598.465 8.19345 597.061 -6.71564 571.738 3.69146C571.738 3.69146 551.621 9.59657 533.193 37.1713C514.765 64.746 517.999 78.8822 517.999 78.8822V78.8897Z",
    fill: "url(#paint0_linear_1022_124501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1845 79.2427C89.1845 79.2427 75.3934 26.4043 12.6507 22.9978C12.6507 22.9978 -3.1063 21.8423 0.555317 43.2267C3.98433 63.2606 11.12 112.43 38.7247 131.293C43.3467 134.452 49.2068 135.45 54.5192 133.679C56.4925 133.019 58.4059 131.991 59.884 130.385C64.9488 124.9 81.6212 119.731 86.4758 111.394C91.3304 103.058 97.063 94.9021 89.1845 79.2502V79.2427Z",
    fill: "url(#paint1_linear_1022_124501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.299 56.8001C441.435 47.406 445.9 37.5691 452.022 31.1388C454.476 28.5651 456.982 26.0365 459.361 23.3878C464.073 18.1355 472.686 10.167 481.555 10.167C481.555 10.167 496.464 10.167 504.065 26.2016C511.666 42.2362 517.991 47.8637 517.991 82.0563C517.991 116.249 510.818 132.981 476.491 139.599C442.163 146.217 434.72 133.552 432.394 127.361C430.96 123.542 431.133 107.643 431.478 96.0124C431.876 82.6865 434.074 69.4582 438.299 56.8076V56.8001Z",
    fill: "url(#paint2_linear_1022_124501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.038 94.8568C182.038 94.8568 174.557 41.7933 138.714 27.4545C137.498 26.9668 136.313 26.434 135.12 25.8938C130.303 23.7103 116.684 18.9382 108.453 30.1407C108.453 30.1407 89.1769 45.1923 89.1769 79.2424C89.1769 113.292 94.2416 132.764 126.596 141.46C142.263 145.669 153.968 145.197 161.877 143.598C168.322 142.293 174.227 139.089 178.917 134.474L186.337 127.166L182.03 94.8643L182.038 94.8568Z",
    fill: "url(#paint3_linear_1022_124501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.065 111.597C180.065 111.597 176.448 156.549 211.136 160.766C245.824 164.983 278.396 166.251 292.232 157.179C306.068 148.108 304.815 137.573 303.164 109.766C301.543 82.4764 275.627 8.61377 232.423 8.61377C189.219 8.61377 180.065 85.005 180.065 111.597Z",
    fill: "url(#paint4_linear_1022_124501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.558 130.73C305.558 130.73 311.275 34.515 370.844 11.5774C377.694 8.94373 385.265 8.72613 392.176 11.1797C399.086 13.6333 407.648 18.8781 415.271 29.8255C419.931 36.5109 423.187 44.0593 425.138 51.9678C428.897 67.222 435.507 100.739 429.64 129.74C429.64 129.74 423.802 152.955 403.333 157.592C382.864 162.229 333.237 167.009 317.863 157.592C304.425 149.361 305.55 130.723 305.55 130.723L305.558 130.73Z",
    fill: "url(#paint5_linear_1022_124501)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.485 109.907C521.022 104.467 518.446 92.1154 517.973 84.7453C517.588 117.13 509.902 133.156 476.487 139.598C442.16 146.216 434.716 133.55 432.39 127.36C431.816 125.831 431.5 122.364 431.349 118.009C430.974 121.963 430.415 125.891 429.637 129.739C429.637 129.739 423.799 152.954 403.33 157.591C382.861 162.228 333.234 167.008 317.86 157.591C304.421 149.36 305.547 130.722 305.547 130.722L305.554 130.729C305.554 130.729 311.272 34.5142 370.841 11.5766C377.691 8.94291 385.262 8.72531 392.173 11.1789C399.083 13.6325 407.644 18.8773 415.268 29.8246C419.927 36.5101 423.184 44.0584 425.135 51.9669C427.337 60.9044 430.518 76.1113 431.595 93.0058C432.215 80.6984 434.389 68.5053 438.296 56.8064V56.7989C441.432 47.4047 445.896 37.5679 452.019 31.1375C452.71 30.4132 453.404 29.6924 454.099 28.9715L454.109 28.961C455.88 27.124 457.651 25.2862 459.357 23.3866C464.069 18.1343 472.683 10.1657 481.552 10.1657C481.552 10.1657 496.461 10.1657 504.062 26.2003C505.298 28.8086 506.501 31.1415 507.648 33.3667C512.957 43.6642 517.077 51.6569 517.855 73.9669C518.312 67.6637 521.053 55.3318 533.19 37.1703C551.618 9.5956 571.734 3.69049 571.734 3.69049C597.058 -6.71661 598.461 8.19248 598.461 8.19248C603.811 52.9348 587.626 86.5571 577.925 106.111C568.223 125.664 555.7 123.413 555.7 123.413C546.599 120.829 545.394 119.439 543.709 117.495C542.229 115.789 540.378 113.654 532.485 109.907ZM517.996 78.8887C517.996 78.8887 517.986 78.9807 517.972 79.1552C517.971 79.0149 517.969 78.8752 517.967 78.736C517.974 78.7749 517.98 78.8061 517.985 78.8294C517.992 78.8639 517.996 78.8812 517.996 78.8812V78.8887ZM90.7133 103.675C93.8876 123.006 102.96 135.107 126.593 141.459C142.26 145.668 153.965 145.196 161.873 143.597C168.319 142.292 174.224 139.088 178.913 134.473L181.806 131.624C184.772 144.207 192.318 158.478 211.132 160.765C245.82 164.982 278.392 166.25 292.228 157.178C305.495 148.48 304.889 138.437 303.362 113.113C303.296 112.025 303.229 110.91 303.161 109.765C301.54 82.4753 275.624 8.61269 232.419 8.61269C197.766 8.61269 185.018 57.7589 181.33 90.9339C178.794 78.3986 168.64 39.4264 138.711 27.4535C137.495 26.9658 136.31 26.4331 135.116 25.8929C130.299 23.7094 116.681 18.9373 108.45 30.1397C108.45 30.1397 89.1842 45.1832 89.1737 79.2136C88.8061 77.8465 74.5567 26.3578 12.6472 22.9965C12.6472 22.9965 -3.10972 21.841 0.551899 43.2254C0.705555 44.1232 0.866654 45.0794 1.03671 46.0888L1.03695 46.0902L1.03734 46.0925L1.03749 46.0934L1.03751 46.0936C4.66266 67.6118 12.3555 113.275 38.7213 131.292C43.3433 134.451 49.2034 135.449 54.5158 133.678C56.4891 133.018 58.4025 131.99 59.8806 130.384C61.9514 128.141 65.9625 125.952 70.3129 123.576C76.6031 120.142 83.6026 116.321 86.4724 111.393C86.7237 110.962 86.9773 110.53 87.2313 110.099C88.4598 108.011 89.6962 105.91 90.7133 103.675Z",
    fill: "#DBDAD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1022_124501",
    x1: 599.53,
    y1: -145.189,
    x2: 599.53,
    y2: 151.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEBEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DDD3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E9E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F1EFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F8F8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4201,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBBAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1022_124501",
    x1: 38.6422,
    y1: -98.6684,
    x2: 38.6422,
    y2: 154.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEBEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DDD3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E9E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F1EFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBBAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1022_124501",
    x1: 431.238,
    y1: 22.5101,
    x2: 431.238,
    y2: 192.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEBEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DDD3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E9E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F1EFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBBAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1022_124501",
    x1: 124.555,
    y1: 16.8823,
    x2: 124.555,
    y2: 185.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEBEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DDD3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E9E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F1EFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBBAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1022_124501",
    x1: 304.154,
    y1: 8.25363,
    x2: 304.154,
    y2: 195.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEBEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DDD3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E9E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F1EFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBBAB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1022_124501",
    x1: 431.973,
    y1: 3.75138,
    x2: 431.973,
    y2: 220.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEBEBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#DDD3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E9E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F1EFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6F6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBBAB6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1022_124501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 599.53,
    height: 164,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryMaxillary1);
export default __webpack_public_path__ + "static/media/library_maxillary1.168267d1f00e0b4adfc4514c48af3d74.svg";
export { ForwardRef as ReactComponent };